function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { thresholdDisplayName } from '../../../../../reducers/selectors/usage.caps.selectors.helper';
import { USAGE_CAP_BEHAVIOR_TYPES, USAGE_CAPS_INDICATOR_BREACHED_ICON, USAGE_CAPS_INDICATOR_NORMAL_ICON } from '../usage.caps.constants';
export var UsageCapIndicatorController = /*#__PURE__*/function () {
  function UsageCapIndicatorController($ngRedux) {
    _classCallCheck(this, UsageCapIndicatorController);
    Object.assign(this, {
      capBehaviorTypes: USAGE_CAP_BEHAVIOR_TYPES,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      hasBreachedCaps: false,
      indicatorIcon: USAGE_CAPS_INDICATOR_NORMAL_ICON,
      indicatorLabel: '',
      tooltipContext: {}
    });
    this.$ngRedux = $ngRedux;
    if (!this.usageCapsArray) {
      this.usageCapsArray = [];
    }
  }
  return _createClass(UsageCapIndicatorController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget() {
        return {};
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, {})(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.toolTipTemplate = require('./usage.cap.indicator.tooltip.template.html');
      this.indicatorLabel = this.getUsageCapLabel(this.usageCapsArray);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.usageCapsArray && changesObj.usageCapsArray.currentValue && Object.keys(changesObj.usageCapsArray.currentValue).length) {
        this.tooltipContext.formattedCapsObject = this.formatUsageCaps(changesObj.usageCapsArray.currentValue);
        this.indicatorIcon = this.determineIndicatorIcon();
        this.indicatorLabel = this.getUsageCapLabel(changesObj.usageCapsArray.currentValue);
      }
    }
  }, {
    key: "getUsageCapLabel",
    value: function getUsageCapLabel(capsArray) {
      if (capsArray && capsArray.length) {
        var usageCapLabel = '';
        if (capsArray.length > 1) {
          usageCapLabel = i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.USAGE_CAP_INDICATOR.MULTIPLE, {
            numberOfCaps: capsArray.length
          });
        } else {
          usageCapLabel = i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.USAGE_CAP_INDICATOR.SINGLE);
        }
        return usageCapLabel;
      }
    }
  }, {
    key: "determineIndicatorIcon",
    value: function determineIndicatorIcon() {
      if (this.hasBreachedCaps) {
        return USAGE_CAPS_INDICATOR_BREACHED_ICON;
      }
      return USAGE_CAPS_INDICATOR_NORMAL_ICON;
    }
  }, {
    key: "getBrechedCapMessage",
    value: function getBrechedCapMessage() {
      return _defineProperty(_defineProperty(_defineProperty({}, USAGE_CAP_BEHAVIOR_TYPES.DiscountToZero, i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.USAGE_CAP_INDICATOR.USAGE_ALLOWED_DISCOUNT_ZERO)), USAGE_CAP_BEHAVIOR_TYPES.ProcessPayment, i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.USAGE_CAP_INDICATOR.PROCESS_PAYMENT)), USAGE_CAP_BEHAVIOR_TYPES.RestrictUsage, i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.USAGE_CAP_INDICATOR.USAGE_RESTRICTED));
    }
  }, {
    key: "formatUsageCaps",
    value: function formatUsageCaps(usageCapsArray) {
      var _this2 = this;
      this.hasBreachedCaps = usageCapsArray === null || usageCapsArray === void 0 ? void 0 : usageCapsArray.some(function (cap) {
        return cap.Breached && cap.UsageCapBehavior === _this2.capBehaviorTypes.RestrictUsage;
      });
      var getUsageCapsForTooltip = function getUsageCapsForTooltip(cap) {
        var _this2$getBrechedCapM;
        return {
          breachedCapMessage: cap !== null && cap !== void 0 && cap.UsageCapBehavior ? (_this2$getBrechedCapM = _this2.getBrechedCapMessage()) === null || _this2$getBrechedCapM === void 0 ? void 0 : _this2$getBrechedCapM[cap.UsageCapBehavior] : '',
          isUsageRestricted: cap.UsageCapBehavior === _this2.capBehaviorTypes.RestrictUsage,
          id: cap.Id,
          name: cap.Name,
          threshold: thresholdDisplayName(cap.ElectedThreshold, cap.ThresholdType, _this2.businessUnitCurrencyCode)
        };
      };
      return usageCapsArray && usageCapsArray.map(getUsageCapsForTooltip);
    }
  }]);
}();
export default {
  template: require('./usage.cap.indicator.html'),
  controller: UsageCapIndicatorController,
  bindings: {
    usageCapsArray: '<',
    businessUnitCurrencyCode: '<',
    alwaysVisible: '<?'
  },
  controllerAs: 'UsageCapIndicatorController'
};